/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DataBookIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Data Book',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <ellipse cx="18" cy="7" rx="16" ry="5" />
    <path
      d="M10.6 29.766a10.425 10.425 0 0 1 1.819-5.55l.209-.281C8.117 23.408 3.245 22.244 2 20.27V29c0 2.029 3.874 3.771 9.429 4.555a9.315 9.315 0 0 1-.829-3.789ZM34 12.8v-2.53a9.226 9.226 0 0 1-4.529 2.53ZM19.729 14.39c.044-.058.1-.1.149-.156-.665.027-1.3.041-1.877.041-4.936 0-14.212-1.168-16-4V17c0 2.349 5.191 4.314 12.179 4.851ZM27.656 32.883h-7.935a2.922 2.922 0 0 1-3.113-3.117 2.927 2.927 0 0 1 3.113-3.116h8.509a.779.779 0 0 0 .623-.312l6.831-9.714a.39.39 0 0 0-.311-.624H22.911a.779.779 0 0 0-.623.312l-7.3 9.814A6.219 6.219 0 0 0 20.01 36h8.22a.779.779 0 0 0 .623-.312l6.831-9.714a.39.39 0 0 0-.312-.623h-2.521Z"
    />
  </svg>`;
};
